import { render } from "./ChangeParent.vue?vue&type=template&id=537fc2fe&scoped=true"
import script from "./ChangeParent.vue?vue&type=script&lang=js"
export * from "./ChangeParent.vue?vue&type=script&lang=js"

import "./ChangeParent.vue?vue&type=style&index=0&id=537fc2fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537fc2fe"]])

export default __exports__